// @ts-strict-ignore
import { createSelector } from '@reduxjs/toolkit'

import { RootState } from 'store/rootReducer'

import { LocalProduct, TBurger, TBurgerLevel1, TSection } from '@/shared/types/deprecated-types'
import { TProductCode } from '@/shared/types/product-types'

// TODO Селекты должны импортироваться по дефолту всем файлом и использоваться как selector.product

export const localCartItemsNew = (state: RootState): Record<string, LocalProduct[]> => state.localProductsList.items

/**
 * Return cart item by product id
 * @param productId
 * @param relatedId
 */

/**
 * The local list of accessories and services
 */
export const localCartItems =
	(relatedId: number) =>
	({ localProductsList }: RootState): LocalProduct[] => {
		const { items } = localProductsList

		return items[relatedId] || []
	}

/**
 * Full categories state
 * @param state
 */
export const fullCategoriesState = (state: RootState) => state.categories

// TODO Повсюду проблемы с типами, селекторы возвращают any
/**
 * Full categories items
 * @param state
 */
export const categoriesItems = ({ categories }: RootState): TSection[] => categories.items

/**
 * KOD values of products, added to favorites
 * @param favorites
 */
export const favorites = ({ favorites }: RootState): TProductCode[] => favorites.items

/**
 * The list of "KOD" values of products in compare
 * @param compare
 */
export const compareItemsCodes = ({ compare }: RootState): TProductCode[] => compare.itemsCodes

/**
 * Full categories burger
 * @param state
 */
export const fullCategoriesBurger = (state: RootState): TBurgerLevel1[] => state.categories?.burger

/**
 * Select header categories in top menu
 */
export const selectHeaderCategories = createSelector(fullCategoriesBurger, categories =>
	categories?.filter(({ SHOW_TOP_MENU }) => SHOW_TOP_MENU)
)

export const burgerMenu = (state: RootState): TBurger => state.burger
